import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "sensor-accordion-panel__list" }
const _hoisted_3 = ["aria-expanded", "aria-controls", "onPointerenter", "onClick"]
const _hoisted_4 = { class: "sensor-accordion-panel__card-head" }
const _hoisted_5 = { class: "sensor-accordion-panel__copy" }
const _hoisted_6 = { class: "sensor-accordion-panel__title" }
const _hoisted_7 = ["aria-hidden"]
const _hoisted_8 = ["id"]
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = ["src", "alt"]

import { computed, onBeforeUnmount, ref } from 'vue'

export interface SensorAccordionPanelItem {
  key: string
  title: string
  description: string
  image: string
  imageAlt?: string
  imageFit?: 'cover' | 'contain'
  imagePosition?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SensorAccordionPanel',
  props: {
    items: {},
    ariaLabel: { default: '' },
    mediaLabel: { default: '' },
    defaultActiveKey: { default: '' }
  },
  setup(__props: any) {

const props = __props

const getFirstKey = () => props.items[0]?.key || ''
const activeKey = ref(props.defaultActiveKey || getFirstKey())

const activeItem = computed(() => (
  props.items.find((item) => item.key === activeKey.value) || props.items[0]
))

const currentKey = computed(() => (
  props.items.some((item) => item.key === activeKey.value) ? activeKey.value : getFirstKey()
))

const panelStyle = computed(() => ({
  '--sensor-item-count': String(Math.max(props.items.length, 1)),
  '--sensor-row-tracks': props.items.length
    ? props.items
      .map((item) => item.key === currentKey.value ? 'var(--sensor-card-expanded-height)' : 'var(--sensor-card-collapsed-height)')
      .join(' ')
    : '1fr'
}))

let hoverActivationTimer: ReturnType<typeof window.setTimeout> | null = null

const cancelHoverActivation = () => {
  if (hoverActivationTimer !== null) {
    window.clearTimeout(hoverActivationTimer)
    hoverActivationTimer = null
  }
}

const activateKey = (key: string) => {
  cancelHoverActivation()
  if (key !== activeKey.value) {
    activeKey.value = key
  }
}

const scheduleActivate = (key: string) => {
  cancelHoverActivation()
  hoverActivationTimer = window.setTimeout(() => {
    activateKey(key)
  }, 64)
}

onBeforeUnmount(() => {
  cancelHoverActivation()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "sensor-accordion-panel",
    "aria-label": _ctx.ariaLabel,
    style: _normalizeStyle(panelStyle.value)
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("button", {
          key: item.key,
          class: _normalizeClass(["sensor-accordion-panel__card", { 'sensor-accordion-panel__card--active': currentKey.value === item.key }]),
          type: "button",
          "aria-expanded": currentKey.value === item.key,
          "aria-controls": `sensor-accordion-panel-description-${item.key}`,
          onPointerenter: ($event: any) => (scheduleActivate(item.key)),
          onPointerleave: cancelHoverActivation,
          onClick: ($event: any) => (activateKey(item.key))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(item.title), 1),
              _createElementVNode("div", {
                class: "sensor-accordion-panel__description-wrap",
                "aria-hidden": currentKey.value !== item.key
              }, [
                _createElementVNode("p", {
                  id: `sensor-accordion-panel-description-${item.key}`,
                  class: "sensor-accordion-panel__description"
                }, _toDisplayString(item.description), 9, _hoisted_8)
              ], 8, _hoisted_7)
            ])
          ])
        ], 42, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("figure", {
      class: _normalizeClass(["sensor-accordion-panel__media", { 'sensor-accordion-panel__media--contain': activeItem.value?.imageFit === 'contain' }]),
      "aria-label": _ctx.mediaLabel
    }, [
      _createVNode(_Transition, { name: "sensor-accordion-panel__image" }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("img", {
            key: currentKey.value,
            class: _normalizeClass(["sensor-accordion-panel__image", { 'sensor-accordion-panel__image--contain': activeItem.value?.imageFit === 'contain' }]),
            src: activeItem.value?.image,
            alt: activeItem.value?.imageAlt || activeItem.value?.title || '',
            style: _normalizeStyle({ objectPosition: activeItem.value?.imagePosition || '' }),
            loading: "lazy"
          }, null, 14, _hoisted_10))
        ]),
        _: 1
      })
    ], 10, _hoisted_9)
  ], 12, _hoisted_1))
}
}

})